
  import Vue from 'vue';
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title,
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title
          },
          {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Trigunatmaka Traimurti Datta Ha Jana" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Aarti "Trigunatmaka Traimurti Datta Ha Jana" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: 'Datta Aarti, Aarti for Lord Dattatreya, Trigunatmaka Traimurti Datta Ha Jana, swami samarth aarti, दत्ताची आरती मराठी, दत्ताची आरती lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Trigunatmaka Traimurti Datta Ha Jana, Datta Aarti, Aarti for Lord Dattatreya, Dattatreya Aarti, Aarti Lyrics, Datta Bhajan, Dattaji Ki Aarti, Tridev  Aarti in Marathi, दत्ताची आरती मराठी, दत्ताची आरती lyrics, आरती श्री गुरुदत्ताची आरती गुरुमाऊली ची, दत्ताची आरती, swami samarth aarti'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/dattatreya.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/dattatreya.webp'
          },
        ],
      }
    },
  
    components: {
      },
      data() {
        return {
          title: 'Trigunatmaka Traimurti Datta Ha Jana | Dattatreya Aarti - त्रिगुणात्मक त्रैमूर्ती दत्त हा जाणा(दत्ताची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/dattatreya"
        },
        "headline": "Trigunatmaka Traimurti Datta Ha Jana - त्रिगुणात्मक त्रैमूर्ती दत्त हा जाणा(दत्ताची आरती)",
        "name" : "Trigunatmaka Traimurti Datta Ha Jana - Dattatreya Aarti",
        "description": "Explore the full lyrics of Aarti 'Trigunatmaka Traimurti Datta Ha Jana' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/dattatreya.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }
  